import { Injectable } from '@angular/core';
import * as alasql from 'alasql';

@Injectable()
export class TableExporterService {
	constructor() {
		console.log('SRV|TABLE EXPORTER ALIVE!');
	}

	toCsv(filename,data) {
		console.log('ALASQL', filename, data);
		alasql.promise('SELECT * INTO CSV("'+filename+'.csv",{headers:true}) FROM ?', [data])
			.then(
				() => { console.log('EXPORT DATA SAVED') }
			)
			.catch(
				(err) => { console.log('EXPORT DATA ERROR', err) }
			);
	}
}
